import httpClient from 'api/httpClient';

export const getRecurringOrders = (pageNumber: number, searchInput: string) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/recurring-orders',
    params: {
      pageNumber,
      searchTerm: searchInput,
    },
  });
};
